import { unsupported } from '../errors'
import type { EnlaceService } from './types'

/**
 * El backend no tiene reenvío del enlace (docs/backend/enlace.md). Hasta que exista
 * `POST /guest-links/resend`, la implementación real falla de forma explícita y la pantalla
 * muestra el estado vacío del bloque de reenvío.
 */
export const enlaceReal: EnlaceService = {
  resend() {
    return unsupported()
  },
}
